<template>
    <div class="works">
        <div class="text">
            <p>how <span>it</span> works</p>
            <p>Ready to experience the convenience and 
                comfort of our ride hailing service? Book your ride 
                today and get where you need to go with ease
            </p>
        </div>
        <div class="box">
            <div class="map">
                <div class="image">
                    <img src="../../assets/map.png" alt="map">
                </div>
            </div>
            <div class="vector">
                <img src="../../assets/Group275.png" alt="image" width="80">
            </div>
            <div class="mesg">
                <div class="data">
                    <div class="img">
                        <img src="../../assets/Vector11.svg" alt="image">
                    </div>
                    <div class="txt">
                        <p>Simple Fast and Easy:</p>
                        <p>
                            Simply open the app, choose your destination, connect with a driver
                            and enjoy your comfortable ride, nice and easy. You can Book a ride or 
                            Schedule  Ride as your comfort demands and our driver will be available
                             to pick you up in a short time. 
                        </p>
                    </div>
                </div>
                <div class="data">
                    <div class="img">
                        <img src="../../assets/Vector.svg" alt="image">
                    </div>
                    <div class="txt">
                        <p>Affordable:</p>
                        <p>
                            You First! We believe that everyone should have access to safe,
                             reliable and pleasurable transportation which is why we offer low prices on all our rides
                        </p>
                    </div>
                </div>
                <div class="data">
                    <div class="img">
                        <img src="../../assets/Group.svg" alt="image">
                    </div>
                    <div class="txt">
                        <p>Responsive: </p>
                        <p>You can always reach our 24/7 customer support to give you assistance 
                            on our services. 

                        </p>
                    </div>
                </div>
            </div>
           
        </div>
        
    </div>
</template> 
<script>
    export default {
        mounted() {
            window.addEventListener('scroll', this.scrolling)
        },
        methods: {
            scrolling(){
                const elem = document.querySelectorAll('.data')
                for (var i = 0; i < elem.length; i++) {
                    var listItem = elem[i];
                    if (this.visible(listItem)) {
                    listItem.classList.add('active')
                    }else{
                    listItem.classList.remove('active')
                    }
                }
                
                },
                visible(arg) {
                const elem = arg.getBoundingClientRect()
                const bottom = elem.bottom
                const height = elem.height
                return (height + window.innerHeight >= bottom)
            }
        }
    }
</script>
<style scoped>
    .works{
        position: relative;
        width: 100%;
        margin: 0;
        margin-bottom: 3rem;
    }
    .works .text{
        max-width: 480px;
        position: relative;
        margin: 0;
        text-align: center;
        padding: 1rem;
        left: 50%;
        transform: translateX(-50%);
    }
    .text p:nth-child(1){
        font-weight: 400;
        font-size: 26px;
        color: #000;
        margin-bottom: 1rem;
        text-transform: uppercase;
        font-family: 'Helvetica', sans-serif;
    }
    .text p:nth-child(1) span{
        color: #f60;
    }
    .text p:nth-child(2){
        font-size: 14px;
        color: #9e9da2;
        line-height: 22px;
        font-family: 'Helvetica', sans-serif;
    }
    .works .box{
        position: relative;
        width: 100%;
        margin: 0;
        padding: 0;
    }
    .box .map{
            padding: 1rem;
            align-self: center;
        }
        .map .image{
            position: relative;
            width: 100%;
            height: 250px;
            align-self: center;
        }
        .map .image .img{
            position: relative;
            width: 100%;
            height: 200px;
        }
        .map .image img{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }
    .box .mesg{
        position: relative;
        width: 100%;
        margin: 0;
        padding: 1rem;
        overflow: hidden;
    }
     .data{
        position: relative;
        padding: 12px;
        width: 100%;
        margin-bottom: 1rem;
        background-color: #fff;
        border-radius: 8px;
        text-align: center;
        box-shadow: 3px 3px 15px rgba(0, 0, 0, 0.2);
        font-family: 'Gotham', sans-serif;
        transform: translate3d(50px, 0, 0);
        transition: all .5s ease-out;
        opacity: 0;
    }
    .active {
        transform: translate3d(0, 0, 0);
        opacity: 1;
    }
    .mesg .data .img{
        display: inline-block;
        padding: 12px;
        background-color: rgba(255, 199, 0, 0.1);
        border-radius: 8px;
    }
    .mesg .data p:nth-child(1){
        font-size: 15px;
        font-weight: 700;
        color: #0e243a;
        margin-bottom: 7px;
        text-transform: initial;
    }
    .mesg .data p:nth-child(2){
        font-style: italic;
        font-weight: 500;
        line-height: 17px;
        font-size: 12px;
        color: #393e43;
    }
    .box .vector{
        display: none;
    }
    @media screen and (min-width:768px) {
        .works .text{
            max-width: 480px;
        }
        .box .mesg{
            padding: 1rem;
            padding-left: 0;
        }
        .text p:nth-child(1){
            font-size: 34px;
        }

        .text p:nth-child(2){
            font-size: 16px;
            line-height: 18px;
        }
        .works .box{
            display: grid;
            grid-template-columns: 1fr 1fr;
        }
       
        .box .mesg{
            padding: 1rem 2rem;
        }
        .mesg .data{
            display: flex;
            text-align: left;
            /* min-width: 360px; */
            align-items: center;
            gap: 10px;
        }
    }
    @media screen and (min-width:1010px) {
        .works .text{
            max-width: 480px;
        }
        .works .box{
        padding-bottom: 4rem;
        }
        .map .image{
            width: 100%;
            height: 280px;
            align-self: center;
        }
        .mesg .data{
            align-self: flex-start;
            width: 450px;
            padding: 2rem;
            margin-bottom: 2rem;
        }
        .text p:nth-child(1){
            font-size: 42px;
        }
        .box .vector{
            display: unset;
            position: absolute;
            right: 20px;
            bottom: 40px;
            
        }
    }

    @media screen and (min-width:1280px) {
        .works .text{
            max-width: 580px;
        }
      
        .box .map{
            padding-left: 3rem;
        }
        .map .image{
            width: 90%;
            align-self: center;
        }
        .mesg .data{
            align-self: flex-start;
            width: 550px;
            padding: 2rem;
        }
        .text p:nth-child(1){
            font-size: 46.53px;
        }

        .text p:nth-child(2){
            font-size: 20px;
            line-height: 26px;
        }
        .box .vector{
            right: 40px;
            bottom: 0px;
            
        }
    }

</style>